import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { LuDownload, LuFileText } from 'react-icons/lu';
import { toast } from 'react-toastify';

import Spinner from '~/components/icons/Spinner';
import { getChatDownloadRoute } from '~/features/whatsapp/utils/resolveChatAttachmentDownloadName';
import { downloadFile } from '~/utils/downloadFile';

type Props = {
    chatId: string;
    displayName: string;
    mediaKey: string;
};

export const DocumentDownloadRow = ({ chatId, displayName, mediaKey }: Props) => {
    const { t } = useTranslation();
    const [isDownloading, setIsDownloading] = useState(false);

    const handleDownload = async () => {
        setIsDownloading(true);
        try {
            await downloadFile({
                name: displayName,
                route: getChatDownloadRoute(chatId, mediaKey),
            });
        } catch {
            toast.error(t('WHATSAPP_CHAT.ATTACHMENT.DOWNLOAD_FAILED'));
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <button
            type="button"
            onClick={handleDownload}
            disabled={isDownloading}
            className="flex w-full items-center gap-2 rounded-md border border-outline-light bg-white px-3 py-2 text-left text-xs text-midnight hover:bg-surface-light disabled:opacity-50"
        >
            {isDownloading ? <Spinner className="h-4 w-4 shrink-0" /> : <LuFileText className="size-4 shrink-0" />}
            <span className="truncate">{displayName}</span>
            <LuDownload className="ml-auto size-4 shrink-0" />
        </button>
    );
};
